/**
 * Gmail address detection for Google Drive sharing.
 *
 * A `gmail.com` / `googlemail.com` address is known to be a Google account, so
 * Drive files can be shared to it directly. A Google Workspace address cannot
 * be recognised from its domain alone, so it is not treated as a Google account
 * here — the expert is asked for one instead.
 */
const GMAIL_DOMAINS = new Set(['gmail.com', 'googlemail.com']);

/**
 * Returns `email` trimmed and lower-cased when it is a Gmail address, otherwise
 * null. Gmail addresses are case-insensitive, so the normalised form is the one
 * to store and compare.
 */
export function gmailAddressOrNull(email: string | null | undefined): string | null {
  const normalized = (email ?? '').trim().toLowerCase();
  const at = normalized.lastIndexOf('@');
  if (at < 1 || /\s/.test(normalized)) return null;
  return GMAIL_DOMAINS.has(normalized.slice(at + 1)) ? normalized : null;
}
